<div id="toggler" class="row py-2 align-items-center" (click)="isCollapsed = !isCollapsed">
    <div class="col-1">
        <fa-icon [icon]="isCollapsed ? faChevronDown : faChevronUp" aria-hidden="true"></fa-icon>
    </div>
    <div class="col-lg-2 col-5" data-got="first-column">
        {{ firstColumnValue }}
    </div>
    <div class="col-lg-1 col-2">{{ task.notificationType }}</div>
    <div class="col-1 d-none d-lg-block">{{ task.taskCode }}</div>
    <div class="col-1 d-none d-lg-block">{{ task.shortText }}</div>
    <div class="col-1 d-none d-lg-block">
        @if (task.showMatIcon) {
            <fa-icon [icon]="faBox"></fa-icon>
        }
    </div>
    <div class="col-2 d-none d-lg-block">{{ formattedPlannedDate }}</div>
    <div class="col-1 d-none d-lg-block">
        {{ formattedDeadlineDate }}
    </div>
    <div class="col-lg-2 col-4 text-center">
        @if (task.canGetTask) {
            <fa-icon [icon]="faDownload" (click)="getTaskClickHandler(task)"></fa-icon>
        }
    </div>
</div>
@if (!isCollapsed) {
    <div class="py-3" [ngClass]="{ collapsed: isCollapsed, expanded: !isCollapsed }">
        @if (isCustomerTab) {
            <div class="row align-items-center my-2">
                <span
                    class="fw-bold col-lg-3 col-5 offset-1"
                    translate="NOTIFICATION_DETAIL_EQUIPMENTS_OTHER_TASKS_TABLE_NOTIFICATION_NUMBER"
                >
                </span>
                <span class="col-lg-8 col-6">{{ task.notificationNo }} ({{ task.taskNo }})</span>
            </div>
            <div class="row align-items-center my-2">
                <span
                    class="fw-bold col-lg-3 col-5 offset-1"
                    translate="NOTIFICATION_DETAIL_EQUIPMENTS_OTHER_TASKS_TABLE_FUNC_LOC"
                ></span>
                <span class="col-lg-8 col-6"> {{ task.funcldescr }}</span>
            </div>
        }
        <div class="d-block d-lg-none">
            <div class="row align-items-center my-2">
                <span
                    class="fw-bold col-lg-3 col-5 offset-1"
                    translate="NOTIFICATION_DETAIL_EQUIPMENTS_OTHER_TASKS_TABLE_TASK"
                >
                </span>
                <span class="col-lg-8 col-6">{{ task.taskCode }}</span>
            </div>
            <div class="row align-items-center my-2">
                <span
                    class="fw-bold col-lg-3 col-5 offset-1"
                    translate="NOTIFICATION_DETAIL_EQUIPMENTS_OTHER_TASKS_TABLE_SHORT_TEXT"
                >
                </span>
                <span class="col-lg-8 col-6">{{ task.shortText }}</span>
            </div>
            <div class="row align-items-center my-2">
                <span
                    class="fw-bold col-lg-3 col-5 offset-1"
                    translate="NOTIFICATION_DETAIL_EQUIPMENTS_OTHER_TASKS_TABLE_MATERIAL"
                >
                </span>
                <span class="col-lg-8 col-6">
                    @if (task.showMatIcon) {
                        <fa-icon [icon]="faBox"></fa-icon>
                    }
                </span>
            </div>
            <div class="row align-items-center my-2">
                <span
                    class="fw-bold col-lg-3 col-5 offset-1"
                    translate="NOTIFICATION_DETAIL_EQUIPMENTS_OTHER_TASKS_TABLE_PLANNED_DATE"
                >
                </span>
                <span class="col-lg-8 col-6">{{ formattedPlannedDate }}</span>
            </div>
            <div class="row align-items-center my-2">
                <span
                    class="fw-bold col-lg-3 col-5 offset-1"
                    translate="NOTIFICATION_DETAIL_EQUIPMENTS_OTHER_TASKS_TABLE_DEADLINE"
                >
                </span>
                <span class="col-lg-8 col-6">{{ formattedDeadlineDate }}</span>
            </div>
        </div>
        <div class="row align-items-center my-2">
            <span
                class="fw-bold col-lg-3 col-5 offset-1"
                translate="NOTIFICATION_DETAIL_EQUIPMENTS_OTHER_TASKS_TABLE_ESTIMATED_DATE"
            ></span>
            <span class="col-lg-8 col-6">{{ taskEstimatedTime }}</span>
        </div>
    </div>
}
